// On-demand loader for the heavy third-party libraries that used to load
// render-blocking on every page (#9195): pdf.js, html2pdf and SheetJS together
// cost ~1.4MB that only preview / export / print flows ever touch.
//
// URLs are origin-relative on purpose: app_mux serves /cdn/ from the same host
// that served the page, in every environment.

// esbuild inlines this module into every bundle that imports it, so the cache
// has to live on window: otherwise two bundles on the same page (say the
// listing's pdf preview and printable's mobile preview) each fetch and execute
// the same library.
window.__lazylibPending = window.__lazylibPending || {};
const pending = window.__lazylibPending;

export function loadScript(url) {
    if (!pending[url]) {
        pending[url] = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = url;
            const timer = setTimeout(() => fail('Timed out loading ' + url), 30000);
            function finish() {
                clearTimeout(timer);
                script.onload = null;
                script.onerror = null;
            }
            function fail(message) {
                finish();
                delete pending[url];
                if (script.parentNode) script.parentNode.removeChild(script);
                reject(new Error(message));
            }
            script.onload = () => {
                finish();
                resolve();
            };
            script.onerror = () => fail('Failed to load ' + url);
            document.head.appendChild(script);
        });
    }
    return pending[url];
}

export function loadXLSX() {
    return loadScript('/cdn/xlsx.mini.min.js').then(() => window.XLSX);
}

export function loadPdfJs() {
    return loadScript('/cdn/pdfjs-dist.min.js').then(() => {
        if (!window.pdfjsLib) {
            delete pending['/cdn/pdfjs-dist.min.js'];
            throw new Error('PDF library did not initialize');
        }
        return window.pdfjsLib;
    });
}

export function loadHtml2Pdf() {
    return loadScript('/cdn/html2pdf.bundle.min.js').then(() => window.html2pdf);
}
